__turbopack_context__.v({
  "img": "VehicleHeroImage-module__jsjpkG__img",
});
